module.exports = __webpack_public_path__ + "static/media/vectors.218f11dd.jpg";